import { useLang } from "@/i18n/LangContext";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function FAQ() {
  const { t } = useLang();
  const items = t("faq.items");
  return (
    <main className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="faq-page">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-brand-cyan mb-3">
        {t("nav.faq")}
      </div>
      <h1 className="font-heading text-4xl md:text-5xl font-bold mb-10">{t("faq.title")}</h1>
      <Accordion type="single" collapsible className="space-y-3">
        {Array.isArray(items) &&
          items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-[#0c0c0c] border border-white/5 rounded-xl px-5"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-start font-heading text-lg hover:no-underline">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 leading-relaxed">{it.a}</AccordionContent>
            </AccordionItem>
          ))}
      </Accordion>
    </main>
  );
}
